module.exports = __webpack_public_path__ + "img/photo07.01225a37.jpg";